export default "__VITE_ASSET__fhUj7yEe__"